import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LABAREA,
  DELETE_LABAREA,
  GET_LABAREAS,
  UPDATE_LABAREA,
  UPDATE_LABAREA_STATUS
} from "./actionTypes";

import {
  addLabAreaFail,
  addLabAreaSuccess,
  deleteLabAreaFail,
  deleteLabAreaSuccess,
  getLabAreasFail,
  getLabAreasSuccess,
  setState,
  updateLabAreaFail,
  updateLabAreaSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { labAreas, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLabAreas({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labAreas, params.toString());
    yield put(setState(false));
    yield put(getLabAreasSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabAreasFail(error));
  }
}

function* updateLabArea({ payload: labAreaObj }) {
  try {
    const { id, recordStatus, ...rest } = labAreaObj;
    yield call(patchApiCall, `${labAreas}/${id}`, rest);
    const response = yield call(getTable, `${labAreas}/${labAreaObj.id}`);
    yield put(updateLabAreaSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    toast.error('Error al actualizar el registro');
    yield put(updateLabAreaFail(error));
  }
}

function* updateLabAreaStatus({ payload: labAreaObj }) {
  try {
    const { id } = labAreaObj;
    yield call(patchApiCall, `${labAreas}/${updateStatus}/${id}`, { recordStatus: labAreaObj.recordStatus });
    const response = yield call(getTable, `${labAreas}/${labAreaObj.id}`);
    yield put(updateLabAreaSuccess(response));
  } catch (error) {
    yield put(updateLabAreaFail(error));
  }
}

function* deleteLabArea({ payload: labAreaObj }) {
  try {
    yield call(deleteApiCall, `${labAreas}/${labAreaObj.id}`);
    yield put(deleteLabAreaSuccess(labAreaObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    toast.error('Error al borrar el registro');
    yield put(deleteLabAreaFail(error));
  }
}

function* postingLabArea({ payload: labArea }) {
  try {
    const response = yield call(postApiCall, labAreas, labArea);
    const responseDetails = yield call(getTable, `${labAreas}/${response.id}`);
    yield put(addLabAreaSuccess(responseDetails));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    toast.error('Error al agregar el registro');
    yield put(addLabAreaFail(error));
  }
}

function* labAreasSaga() {
  yield takeEvery(GET_LABAREAS, fetchLabAreas);
  yield takeEvery(ADD_NEW_LABAREA, postingLabArea);
  yield takeEvery(UPDATE_LABAREA, updateLabArea);
  yield takeEvery(UPDATE_LABAREA_STATUS, updateLabAreaStatus);
  yield takeEvery(DELETE_LABAREA, deleteLabArea);
}

export default labAreasSaga;
